import type { Person } from '../../eventsApi/persons/person'
import type { User } from '../../usersApi/users/user'
import type { Service } from '../services/service'

export class QuotationEntity {
    quotationId: string
    companyId: string
    userId: string
    personId?: string
    title?: string
    notes: string
    isModel: boolean
    invoiceId?: string
    expiresAt: number
    createdAt: Date
    updatedAt: Date
    status: number
    items: Partial<ServiceOnQuotation>[]
    payments: Partial<QuotationPayment>[]
    person: Person
    user: User
}

export class QuotationPayment {
    quotationPaymentId: string
    createdAt: Date
    updatedAt: Date
    dpMethod: string
    dpValue: number
    installmentMethod: string
    installmentFrom: number
    installmentTo: number
    installmentValue: number
    quotationId?: string
}

export class ServiceOnQuotation {
    servicesOnQuotationsId: string
    parentServicesOnQuotationsId?: string
    parentServiceId?: string
    createdAt: Date
    updatedAt: Date
    serviceId: string
    quantity: number
    value: number
    type: string
    quotationId?: string
    service?: Service
}
